import CheckboxIcon from './CheckboxIcon'

export default CheckboxIcon
